import React, { useState } from 'react';
import styles from '../pages/UserDetailsPage.module.css';
import { createNotification, updateNotification, deleteNotification } from '../utils/api';

const Notifications = ({ userId, notifications, setNotifications }) => {
    const [editingNotification, setEditingNotification] = useState(null);
    const [editedNotificationData, setEditedNotificationData] = useState({});
    const [isCreatingNotification, setIsCreatingNotification] = useState(false);
    const [newNotificationData, setNewNotificationData] = useState({
        title: '',
        message: '',
    });

    const handleEditNotification = (notification) => {
        setEditingNotification(notification._id);
        setEditedNotificationData({
            title: notification.title,
            message: notification.message,
            read: notification.read,
        });
    };

    const handleEditedNotificationChange = (e) => {
        const { name, value, type, checked } = e.target;
        setEditedNotificationData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSaveNotification = async (notificationId) => {
        try {
            const res = await updateNotification(notificationId, editedNotificationData);
            setNotifications(notifications.map((n) => (n._id === notificationId ? res.data : n)));
            setEditingNotification(null);
            setEditedNotificationData({});
            alert('Notification updated successfully!');
        } catch (err) {
            console.error('[Admin Frontend] Failed to update notification', err);
            alert('Failed to update notification');
        }
    };

    const handleCancelEditNotification = () => {
        setEditingNotification(null);
        setEditedNotificationData({});
    };

    const handleDeleteNotification = async (notificationId) => {
        if (window.confirm('Are you sure you want to delete this notification?')) {
            try {
                await deleteNotification(notificationId);
                setNotifications(notifications.filter((n) => n._id !== notificationId));
                alert('Notification deleted successfully!');
            } catch (err) {
                console.error('[Admin Frontend] Failed to delete notification', err);
                alert('Failed to delete notification');
            }
        }
    };

    const handleNewNotificationChange = (e) => {
        const { name, value } = e.target;
        setNewNotificationData(prev => ({ ...prev, [name]: value }));
    };

    const handleSaveNewNotification = async () => {
        try {
            const res = await createNotification(userId, newNotificationData);
            setNotifications([res.data, ...notifications]);
            setIsCreatingNotification(false);
            setNewNotificationData({ title: '', message: '' });
            alert('Notification created successfully!');
        } catch (err) {
            console.error('[Admin Frontend] Failed to create notification', err);
            alert('Failed to create notification');
        }
    };

    const handleCancelCreateNotification = () => {
        setIsCreatingNotification(false);
        setNewNotificationData({ title: '', message: '' });
    };

    return (
        <>
            {!isCreatingNotification && (
                <div className={styles['portfolio-actions']}>
                    <button className={styles['btn-approve']} onClick={() => setIsCreatingNotification(true)}>Create New Notification</button>
                </div>
            )}
            {isCreatingNotification && (
                <div className={styles['edit-portfolio-form']}>
                    <h3>Create New Notification</h3>
                    <div className={styles['form-group']}>
                        <label>Title</label>
                        <input type="text" name="title" value={newNotificationData.title} onChange={handleNewNotificationChange} placeholder="Notification Title" />
                    </div>
                    <div className={styles['form-group']}>
                        <label>Message</label>
                        <textarea name="message" value={newNotificationData.message} onChange={handleNewNotificationChange} placeholder="Notification Message" />
                    </div>
                    <div className={styles['portfolio-actions']}>
                        <button className={styles['btn-approve']} onClick={handleSaveNewNotification}>Save Notification</button>
                        <button className={styles['delete-button']} onClick={handleCancelCreateNotification}>Cancel</button>
                    </div>
                </div>
            )}
            <div className={styles['notifications-list']}>
                {notifications.length === 0 ? (
                    <p>No notifications found for this user.</p>
                ) : (
                    notifications.map(notification => (
                        <div key={notification._id} className={styles['transaction-card']}>
                            {editingNotification === notification._id ? (
                                <div className={styles['edit-transaction-form']}>
                                    <div className={styles['form-group']}>
                                        <label>Title:</label>
                                        <input type="text" name="title" value={editedNotificationData.title} onChange={handleEditedNotificationChange} />
                                    </div>
                                    <div className={styles['form-group']}>
                                        <label>Message:</label>
                                        <textarea name="message" value={editedNotificationData.message} onChange={handleEditedNotificationChange} />
                                    </div>
                                    <div className={styles['form-group']}>
                                        <label>Read:</label>
                                        <input type="checkbox" name="read" checked={editedNotificationData.read} onChange={handleEditedNotificationChange} />
                                    </div>
                                    <div className={styles['transaction-card-actions']}>
                                        <button className={styles['btn-approve']} onClick={() => handleSaveNotification(notification._id)}>Save</button>
                                        <button className={styles['delete-button']} onClick={handleCancelEditNotification()}>Cancel</button>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <h3>{notification.title}</h3>
                                    <div className={styles['info-group']}>
                                        <span className={styles['info-label']}>Message:</span>
                                        <span>{notification.message}</span>
                                    </div>
                                    <div className={styles['info-group']}>
                                        <span className={styles['info-label']}>Read:</span>
                                        <span>{notification.read ? 'Yes' : 'No'}</span>
                                    </div>
                                    <div className={styles['info-group']}>
                                        <span className={styles['info-label']}>Time:</span>
                                        <span>{new Date(notification.timestamp).toLocaleString()}</span>
                                    </div>
                                    <div className={styles['transaction-card-actions']}>
                                        <button className={styles['btn-approve']} onClick={() => handleEditNotification(notification)}>Edit</button>
                                        <button className={styles['delete-button']} onClick={() => handleDeleteNotification(notification._id)}>Delete</button>
                                    </div>
                                </>
                            )}
                        </div>
                    ))
                )}
            </div>
        </>
    );
};

export default Notifications;
